export const DIALOG_STYLE = {
  maxWidth: "40rem",
};
